import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/stores/auth';

export function RequireAuth() {
  const status = useAuth((s) => s.status);
  const location = useLocation();

  // 'unknown' means the refresh-cookie check has not finished. Redirecting here
  // would bounce every page reload to the login screen.
  if (status === 'unknown') {
    return (
      <div className="auth-shell">
        <span style={{ color: 'var(--text-muted)' }}>Restoring your session…</span>
      </div>
    );
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}
